import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { actions as freeBetActions } from '../../../common/freeBets'
import { actions as bookmakersInfoActions } from '../../../common/bookmakersInfo'
import FreeBetList from '../../../common/freeBetList'
import FreeBetToggle from '../../../common/freeBetToggle'

export class FreeBetsContainer extends Component {

    constructor() {
        super()
        this.clearFreeBet = this.clearFreeBet.bind(this)
        this.selectFreeBet = this.selectFreeBet.bind(this)
    }

    selectFreeBet(freeBetId) {
        const {
            selectionId,
            selectFreeBet,
            setFreeBetMinimumStake,
            setFreeBetMaximumStake,
            setLockedStake,
            freeBets,
        } = this.props
        const freeBet = freeBets.find(bet => bet.id === freeBetId)
        const {
            minStake,
            maxStake,
            id,
        } = freeBet

        // Update the min/max stake for the selection (if required)
        if (minStake) {
            setFreeBetMinimumStake(selectionId, minStake)
        }
        if (maxStake) {
            setFreeBetMaximumStake(selectionId, maxStake)
        }

        // Set locked stake if applicable
        if (minStake && (minStake === maxStake)) {
            setLockedStake(selectionId, minStake.toString())
        }

        // Set this free bet as being selected
        selectFreeBet(id)
    }

    clearFreeBet() {
        const {
            selectionId,
            clearFreeBet,
            clearLockedStake,
        } = this.props

        clearLockedStake(selectionId)
        clearFreeBet()
    }

    renderFreeBetSingle() {
        const {
            selectedFreeBet,
            freeBets,
            currencySign,
        } = this.props
        return (
            <FreeBetToggle
                selectedFreeBet={selectedFreeBet}
                selectFreeBet={this.selectFreeBet}
                clearFreeBet={this.clearFreeBet}
                freeBets={freeBets}
                currencySign={currencySign}
            />
        )
    }

    renderFreeBetList() {
        const {
            selectedFreeBet,
            freeBets,
            currencySign,
        } = this.props
        return (
            <FreeBetList
                selectedFreeBet={selectedFreeBet}
                selectFreeBet={this.selectFreeBet}
                clearFreeBet={this.clearFreeBet}
                freeBets={freeBets}
                currencySign={currencySign}
            />
        )
    }

    render() {
        const {
            freeBets,
        } = this.props

        const freeBetUi = freeBets.length === 1
            ? this.renderFreeBetSingle()
            : this.renderFreeBetList()

        return (
            <div>
                {freeBetUi}
            </div>
        )
    }
}

FreeBetsContainer.propTypes = {
    freeBets: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
            minStake: PropTypes.number,
            maxStake: PropTypes.number,
            amount: PropTypes.number.isRequired,
        }),
    ).isRequired, // at least 1 free bet, or don't render me
    selectedFreeBet: PropTypes.string,
    currencySign: PropTypes.string.isRequired,
    selectFreeBet: PropTypes.func.isRequired,
    clearFreeBet: PropTypes.func.isRequired,
    selectionId: PropTypes.string.isRequired,
    setFreeBetMinimumStake: PropTypes.func.isRequired,
    setFreeBetMaximumStake: PropTypes.func.isRequired,
    setLockedStake: PropTypes.func.isRequired,
    clearLockedStake: PropTypes.func.isRequired,
}

FreeBetsContainer.defaultProps = {
    selectedFreeBet: null,
}

const mapStateToProps = (state) => {
    const {
        bookmakersInfo,
        freeBets,
    } = state

    return {
        freeBets: freeBets.list,
        selectedFreeBet: freeBets.selectedFreeBet,
        selectionId: bookmakersInfo.selectedBets[0].outcomersId,
    }
}

const mapDispatchToProps = {
    selectFreeBet: freeBetActions.selectFreeBet,
    clearFreeBet: freeBetActions.clearFreeBet,
    setFreeBetMinimumStake: bookmakersInfoActions.setFreeBetMinimumStake,
    setFreeBetMaximumStake: bookmakersInfoActions.setFreeBetMaximumStake,
    setLockedStake: bookmakersInfoActions.setLockedStake,
    clearLockedStake: bookmakersInfoActions.clearLockedStake,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FreeBetsContainer)



// WEBPACK FOOTER //
// /src/js/drawer/components/FreeBetsContainer/FreeBetsContainer.jsx